import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import NextImage from 'next/image';
import {
  BoxSummary,
  ProductSelector,
  ProductSelectorCRO,
} from '@web/components';
import { CheckoutBar } from '../CheckoutBar';
import freshFoodPacks from '../../images/product-photos/pack-shots/fresh_food_packs.png';
import mixedFoodPacks from '../../images/product-photos/pack-shots/mixed_food_packs.png';
import halfFreshFoodPacks from '../../images/product-photos/pack-shots/half_fresh_food_packs.png';
import {
  BoxSummaryContainer,
  HeaderContainer,
  Headline,
  HeroContainer,
  Subheadline,
  StyledImageContainer,
} from './styles';

export const ProductSelectionForm = ({
  checkoutBar,
  boxSummary,
  headline,
  legend,
  subheadline,
  onChange,
  onSubmit,
  productSelector,
  testVariant = 'control',
  CROProps = {},
}) => {
  const dynamicImages = {
    fresh: freshFoodPacks,
    mixed: mixedFoodPacks,
    half_fresh: halfFreshFoodPacks,
  };

  const selectedImage = dynamicImages[CROProps?.selectedPlanType];

  return (
    <form onSubmit={onSubmit}>
      <HeroContainer>
        <HeaderContainer $dynamicImages={CROProps?.dynamicImages || false}>
          <Headline>{headline}</Headline>
          <Subheadline>{subheadline}</Subheadline>
        </HeaderContainer>
        <fieldset>
          {legend && <legend>{legend}</legend>}
          {CROProps && CROProps?.dynamicImages === true && (
            <StyledImageContainer>
              <NextImage
                src={selectedImage.src}
                alt={selectedImage.alt}
                width={338}
                height={158}
              />
            </StyledImageContainer>
          )}
          {testVariant && testVariant === 'control' ? (
            <ProductSelector {...productSelector} onChange={onChange} />
          ) : (
            <ProductSelectorCRO {...productSelector} onChange={onChange} />
          )}
        </fieldset>
        {boxSummary && (
          <BoxSummaryContainer>
            <BoxSummary {...boxSummary} />
          </BoxSummaryContainer>
        )}
      </HeroContainer>
      {ReactDOM.createPortal(
        <form>
          <CheckoutBar {...checkoutBar} />
        </form>,
        document.body,
      )}
    </form>
  );
};
ProductSelectionForm.displayName = 'ProductSelectionForm';
ProductSelectionForm.propTypes = {
  boxSummary: PropTypes.object,
  checkoutBar: PropTypes.object.isRequired,
  headline: PropTypes.string.isRequired,
  legend: PropTypes.string,
  productSelector: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  subheadline: PropTypes.node.isRequired,
  testVariant: PropTypes.string,
  CROProps: PropTypes.object,
};
